import React , { useRef , useState} from "react";
import styled from "styled-components";
import Dialog from '@material-ui/core/Dialog';
import { Checkbox, IconButton } from '@material-ui/core';
import { CloseSharp } from '@material-ui/icons';
import shopsvg from '../../assets/shopsvg.svg'
import usersvg from '../../assets/usersvg.svg'
import MainLogo from '../../assets/luxWhite.svg';
import MainLogoFa from '../../assets/luxFa.svg'
import { Link } from "react-router-dom";
import { UniError, UniErrorHide } from '../Functions/Errors';
import { isLoginOut } from '../../App';
import { checkIsEmail, checkIsMobile } from '../Functions/CheckUserData';
import { Loading } from '../Loading';
import { PostData } from '../Functions/SendingData';
import useInterval from "../Functions/useInterval";
import { logintext } from "../../Lang/fa/Login";
import { makeNumEn } from "../Functions/Numerals";

const Style = styled.div`
    display: flex;
    flex-direction: row;
    direction: rtl;
    min-height: 25rem;
    position: relative;
    width: 100%;
    gap: 5%;
    .login-form{
        width: calc(55% - 10rem);
        padding: 5rem;
        .log-title{
            font-size: var(--fs-login-title);
            font-weight: 800;
        }
        
        .input-form{
            margin-top: 1rem ;
            display: flex;
            flex-direction: column;
            &.signup {
                .log-input{
                    text-align: right;
                }
            }
            .log-text{
                font-size: var(--fs-login-sub);
                font-weight: 700;
                margin-top: 1rem;
            }
            .log-input{
                border: 1px solid #7D7D7D;
                border-radius: var(--radius);
                outline: none;
                width: calc(100% - 1rem);
                padding: 0.5rem ;
                text-align: center;
                justify-content: center;
                margin-top:0.5rem;
            }
            .confirm-login{
                border-radius: var(--radius);
                width: 100%;
                margin:0.5rem auto 0 ;
                padding: 0.5rem 0;
                text-align: center;
                justify-content: center;
                background-color: #EBEDF6;
                outline: none;
                border: none;
                cursor: pointer;
            }
            .confirm-signup{
                border-radius: var(--radius);
                width: 100%;
                margin:0.5rem auto 0 ;
                padding: 0.5rem 0;
                text-align: center;
                justify-content: center;
                /* background-color: #EBEDF6; */
                border: 1px solid #EBEDF6;
                outline: none;
                cursor: pointer;
            }
            
            .subtext{
                font-size: calc(var(--fs-login-sub) - 2px);
                font-weight: 300;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                margin-top: 2rem;
                a{
                    white-space: nowrap;
                    color: var(--primary-2);
                }
            }
            .error{
                margin-top: 0.5rem;
            }
        }
    }
    .modal-close{
        position: absolute;
        width: min-content;
        height: min-content;
        left: 0.5rem;
        top: 0.5rem;
        color: #FFF;
    }
    .left-login{
        background-color:var(--primary-5);
        width: calc(40% - 4rem);
        padding: 2rem;
        display: flex;
        
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .type-svg{
            display: flex;
            margin: 2px 0;
            width: 35%;
            :nth-child(2){
                border-bottom: 1px solid var(--body-2);
            }
        }
    }
    .seller-log{
        background-color: var(--secondry-3);
    }
    @media screen  and (max-width: 850px ) {
        flex-direction: column-reverse;
        width:100% ;
        border-radius: var(--border-radius-1);
        margin: 0;
        .modal-close{
           top: 0;
           left: 0;
        }
        .login-form{
            padding: 2rem;
            width:calc( 100% - 4rem);
            .log-title{
                position: absolute;
                top: 3rem;
                color: var(--text-3);
                display: flex;
                gap: 0.3rem;
            }
            .input-form .subtext{
                text-align: right;
                justify-content: flex-start;
            }
        }
        .left-login{
            padding: 1rem ;
            margin: 0;
            width: calc(100% - 2rem);
            border-bottom-left-radius: var(--border-radius-1);
            align-items: flex-end;
            .type-svg{
                margin-left: 1.5rem;
                width: 16%;
            }
        }
        
    }

`

function ModalLogin({open, setOpen ,name}) {
    const [ email , setEmail] = useState('')
    const [ mobile , setMobile] = useState('')
    const [ ruleCheck , setRuleCheck] = useState(false)
    const [ pass , setPass] = useState(false)
    const [ sending1 , setSending1] = useState(false)
    const [ sending2 , setSending2] = useState(false)
    const [ mobileField , setMobileField] = useState('')
    const [ codeField , setCodeField] = useState('')


    const [signup, setSignup] = useState(false);
    const [signupForm, setSignupForm] = useState({});

    const login = useRef()
    const [timer , setTimer] = useState('')
    const [type , setType] = useState('')
    const [timeA ,setTimeA ]= useState( Date.now() )
    const [timeB ,setTimeB]= useState( 0 )

    const [time , setTime] = useState(120)
    const [puased , setPuased] = useState(true)
    
    const interval = useInterval(
        ()=>{
            if(time > 0){
                setTime( time - 1)
                setTimer( <div className="subtext">ارسال مجدد کد تا {time} ثانیه دیگر</div>)
            }else{
                setPuased(true)
                setTime(0)
                window.clearInterval(interval.current)
                setTimer(<div className="subtext" style={{color:'var(--primary-1)',fontWeight:'500', cursor:'pointer'}} onClick={sendAgain}> {logintext.resend}</div>)
            }
        }
        ,
        puased ? null  : 1000
    )
    const sendForm = (event) => {
        event.preventDefault();
        let formData = new FormData(event.target);
        UniErrorHide();
        PostData(
          process.env.REACT_APP_API + '/api/v1/login',
          formData,
          '',
          LoginResponse
        );
    };
    const LoginResponse=(obj, response)=> {
        response = JSON.parse(response);
        if (response.status === 'success') {
            setSending2(false)
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('userdata', JSON.stringify(response.data));
            isLoginOut();
            setOpen()
        } else if (response.status === 'error') {
            UniError(logintext.wrongcode);
            setSending2(false)
        } else if (response.status === 'error-no-internet') {
            UniError(response.data.message);
            setSending2(false)
        }
    }
    const generatePass = (event, mobile = -1) => {
        event.preventDefault();
        
        let formData = new FormData();
        if (mobile !== -1) {
          formData.set('U_MOBILE', mobile);
        } else {
          formData = new FormData(event.target);
        }
        UniErrorHide();
        let checkMobile = checkIsMobile(formData.get('U_MOBILE'));
        let checkEmail = checkIsEmail(formData.get('U_MOBILE'));
        let type = ''
        if(checkMobile){
          type = 'MOBILE'
        }
        if(checkEmail){
          type = 'EMAIL'
          formData.delete('U_MOBILE')
          formData.set('U_EMAIL', checkEmail)
        }
        console.log(type, ruleCheck)
        if(type === ''){
            UniError(logintext.warnning);
        //   UniError('شماره موبایل یا ایمیل  به درستی وارد نشده است');
            return;
        }
        if(ruleCheck === false){
            UniError(logintext.warnningAccept);
            return;
        }
        let text = <div className="subtext">{logintext.resendtext}</div>;
        setSending1(true)
        setType(type)
        setTimer(text)

        setMobile((checkMobile) ? checkMobile : "")
        setEmail((checkEmail) ? checkEmail : "")
    
        if(checkEmail){
          PostData(
            process.env.REACT_APP_API + '/api/v1/disposable_email',
            formData,
            '',
            PassResponse
          );
        }
        if(checkMobile){
          PostData(
            process.env.REACT_APP_API + '/api/v1/disposable',
            formData,
            '',
            PassResponse
          );
        }
    };
    const PassResponse=(obj, response)=> {
        response = JSON.parse(response); 
        if (response.status === 'success') {
            setSending1(false)
            setTimeA(Date.now())
            setTimeB(1)
            setPass(true)
            setTime(120)
            setPuased(false)
        } else if (response.status === 'error') {
            UniError(logintext.warnning);
            // UniError('شماره موبایل یا ایمیل اشتباه می‌باشد');
            setSending1(false)
            // sendAgain()
        } else if (response.status === 'error-no-internet') {
            UniError(response.data.message);
            setSending1(false)
        }
    }
    const onchange1 = (e) => {
        let temp = makeNumEn(e.target.value);
        let fin = ""
        for (let i = 0; i < temp.length; i++) {
            const chr = temp[i];
            let newint = parseInt(chr);
            if(!isNaN(newint)){
                fin+= chr;
            }
        }
        if(e.target.value === ""){
            fin = ""
        }
        setMobileField(fin)
    }
    const onchange2 = (e) => {
        let value = e.target.value;
        setCodeField(value)    
    }
    const sendAgain = (e) => {
        generatePass(e, mobileField);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const onChangeSignup = (e) => {
        let temp = {...signupForm};
        signupForm[e.target.name] = e.target.value;
        setSignupForm(signupForm)
    }
    const getLoading1 = () => {
        if (sending1) {
          return (
            <div className="confirm-login loading">
              <Loading small={true}/>
            </div>
          );
        } else {
            let disabled = false;
            if(!ruleCheck || !(mobileField.length > 0)){
                disabled = true;
            }
          return (
            <input
              className="confirm-login"
              style={{background:((!disabled) ? 'var(--primary-1)' : ''),color:((!disabled) ? 'var(--text-3)':'')}}
              type="submit"
              value={logintext.sendcode}
              id="submit-form"
            />
          );
        }
    };
    const getLoading2 = () => {
        if(sending2) {
          return (
            <div className="confirm-login loading">
              <Loading small={true}/>
            </div>
          );
        } else {
          return (
            <input
              className={"confirm-login regbtn"}
              disabled={!(codeField.length > 0)}
              style={{background:(codeField.length > 0 ? 'var(--primary-1)' : ''),color:(codeField.length > 0 ? 'var(--text-3)':'')}}
              type="submit"
              value={logintext.continue}
              id="submit-form"
            />
          );
        }
    };
    const rightContetnt= ()=>{
        let error = (
            <div className="subtext error" id="error-container">
              <div id="error" style={{color:'var(--secondry-1)'}}></div>
            </div>
          );
        if(signup) {
            return(
                <form className="login-form signup" ref={login}  onSubmit={(e) => generatePass(e)}>
                    <span className="log-title">{logintext.signup}</span>
                    <div className="input-form signup">
                        <input
                            type="hidden"
                            id="mobile"
                            name="ID_CODE"
                            required="required"
                            value={localStorage.getItem('user-afiliate')}
                            autoComplete="none"
                        />
                        <span className="log-text">نام</span>
                        <input 
                            value={signupForm["Name"]}
                            className='log-input'
                            type ='tell'
                            id='mobile'
                            name="Name" 
                            required="required"
                            onChange={onChangeSignup}
                            style={{direction: 'ltr'}}
                            placeholder={"نام"}
                            // placeholder='شماره موبایل یا ایمیل خود را وارد نمایید'
                            autoComplete="mobile"
                            inputMode='text'
                        />
                        <span className="log-text">نام خانوادگی</span>
                        <input 
                            value={signupForm["Surname"]}
                            className='log-input'
                            type ='tell'
                            id='mobile'
                            name="Surname" 
                            required="required"
                            onChange={onChangeSignup}
                            style={{direction: 'ltr'}}
                            placeholder={"نام خانوادگی"}
                            // placeholder='شماره موبایل یا ایمیل خود را وارد نمایید'
                            autoComplete="mobile"
                            inputMode='text'
                        />
                        <span className="log-text">کد ملی</span>
                        <input 
                            value={signupForm["ID_Code"]}
                            className='log-input'
                            type ='tell'
                            id='mobile'
                            name="ID_Code" 
                            required="required"
                            onChange={onChangeSignup}
                            style={{direction: 'ltr'}}
                            placeholder={"کد ملی"}
                            // placeholder='شماره موبایل یا ایمیل خود را وارد نمایید'
                            autoComplete="mobile"
                            inputMode='text'
                        />
                        <span className="log-text">شماره موبایل</span>
                        <input 
                            value={mobileField}
                            className='log-input'
                            type ='tell'
                            id='mobile'
                            name="U_MOBILE" 
                            required="required"
                            onChange={onchange1}
                            style={{direction: 'ltr'}}
                            placeholder={"شماره موبایل"}
                            // placeholder='شماره موبایل یا ایمیل خود را وارد نمایید'
                            autoComplete="mobile"
                            inputMode='text'
                        />
                        <span className="log-text">شغل</span>
                        <input 
                            value={signupForm["Job"]}
                            className='log-input'
                            type ='tell'
                            id='mobile'
                            name="Job" 
                            required="required"
                            onChange={onChangeSignup}
                            style={{direction: 'ltr'}}
                            placeholder={"شفل"}
                            // placeholder='شماره موبایل یا ایمیل خود را وارد نمایید'
                            autoComplete="mobile"
                            inputMode='text'
                        />
                        <span className="log-text">آدرس محل سکونت</span>
                        <input 
                            value={signupForm["Address"]}
                            className='log-input'
                            type ='tell'
                            id='mobile'
                            name="Address" 
                            required="required"
                            onChange={onChangeSignup}
                            style={{direction: 'ltr'}}
                            placeholder={"آدرس محل سکونت"}
                            // placeholder='شماره موبایل یا ایمیل خود را وارد نمایید'
                            autoComplete="mobile"
                            inputMode='text'
                        />
                        <span className="log-text">نام بانک</span>
                        <input 
                            value={signupForm["Bank"]}
                            className='log-input'
                            type ='tell'
                            id='mobile'
                            name="Bank" 
                            required="required"
                            onChange={onChangeSignup}
                            style={{direction: 'ltr'}}
                            placeholder={"نام بانک"}
                            // placeholder='شماره موبایل یا ایمیل خود را وارد نمایید'
                            autoComplete="mobile"
                            inputMode='text'
                        />
                        <span className="log-text">گردش حساب در ماه</span>
                        <input 
                            value={signupForm["Money"]}
                            className='log-input'
                            type ='tell'
                            id='mobile'
                            name="Money" 
                            required="required"
                            onChange={onChangeSignup}
                            style={{direction: 'ltr'}}
                            placeholder={"گردش حساب در ماه"}
                            // placeholder='شماره موبایل یا ایمیل خود را وارد نمایید'
                            autoComplete="mobile"
                            inputMode='text'
                        />
                        {error}
                        <div className='subtext'> <Link  to='/rules' onClick={handleClose}>  شرایط و قوانین </Link>سایت لوکسین لوکس و حریم خصوصی را می پذیرم.</div>
                        <div className="button-container">{getLoading1()}</div>
                        <div className="button-container">
                            <div className="confirm-signup" onClick={() => setSignup(false)}>
                                {logintext.enter}
                            </div>
                        </div>
                    </div>
                </form>
            )
        }
        if(!pass){
            return(
                <form className="login-form" ref={login}  onSubmit={(e) => generatePass(e)}>
                    <span className="log-title">{logintext.enter}</span>
                    <div className="input-form">
                        <span className="log-text">{logintext.enterPhone}</span>
                        <input
                            type="hidden"
                            id="mobile"
                            name="ID_CODE"
                            required="required"
                            value={localStorage.getItem('user-afiliate')}
                            autoComplete="none"
                        />
                        <input 
                            value={mobileField}
                            className='log-input'
                            type ='tell'
                            id='mobile'
                            name="U_MOBILE" 
                            required="required"
                            onChange={onchange1}
                            style={{direction: 'ltr'}}
                            placeholder={logintext.enterPhone}
                            // placeholder='شماره موبایل یا ایمیل خود را وارد نمایید'
                            autoComplete="mobile"
                            inputMode='text'
                        />
                        {error}
                        <div className='subtext'> 
                            <Checkbox
                                style={{
                                    color: "var(--primary-1)"
                                }}
                                defaultChecked={ruleCheck}
                                onChange={() => setRuleCheck(!ruleCheck)}
                            />
                            <span>
                                <Link  to='/rules' onClick={handleClose}>  شرایط و قوانین </Link>سایت لوکسین لوکس و حریم خصوصی را می پذیرم.
                            </span>
                        </div>
                        <div className="button-container">{getLoading1()}</div>
                        {/* <div className="button-container">
                            <div className="confirm-signup" onClick={() => setSignup(true)}>
                                {logintext.signup}
                            </div>
                        </div> */}
                    </div>
                </form>
            )
        }else{
            return(
                <form className="login-form" ref={login} onSubmit={sendForm}> 
                    {   window.innerWidth < 850 ?
                        (
                            <span className="log-title">{logintext.create}</span>
                        ):''
                    }
                    <div className="input-form">
                        <span className="log-text">{logintext.entercode}</span>
                        <input
                            type="hidden"
                            id="mobile"
                            name="U_TYPE"
                            required="required"
                            value={type}
                            autoComplete="none"
                        />
                        <input
                            type="hidden"
                            id="mobile"
                            name="U_DATA"
                            required="required"
                            value={(mobile) ? mobile : email}
                            autoComplete="none"
                            />
                        <input
                            type="text"
                            id="temp-pass"
                            name="U_DISPOSABLE"
                            required="required"
                            autoComplete="none"
                            className='log-input'
                            value={codeField}
                            onChange={onchange2}
                            placeholder={logintext.entercode}
                            inputMode='decimal'
                        />
                         {error}
                        <div className="timer">{timer}</div>
                        <div className="button-container">{getLoading2()}</div>
                    </div>
                </form>
            )
        }
    }
    const leftContetnt= ()=>{
        if(name === 'seller'){
            return(
                <div className="left-login seller-log">
                    <img src={shopsvg} className='type-svg' alt='shop login'/>
                    <img src={MainLogo} className='type-svg' alt='shop login'/>
                    <img src={MainLogoFa} className='type-svg' alt='shop login'/>
                </div>
            )
        }else{
            return(
                <div className="left-login">
                    <img src={usersvg} className='type-svg' alt='user login'/>
                    <img src={MainLogo} className='type-svg' alt='shop login'/>
                    <img src={MainLogoFa} className='type-svg' alt='shop login'/>
                </div>
            )
        }
    }
            

    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                scroll="body"
                open={open}
                onClose={handleClose}
                style={{backgroundColor: 'rgba(61, 61, 88, 0.77)'}}
            >
                <Style>
                    <IconButton
                        aria-label="close"
                        className='modal-close'
                        onClick={handleClose}
                        sx={{
                        position: 'absolute',
                        top: 0,
                        color: (theme) => theme.palette.red[500],
                        }}
                    >
                        <CloseSharp />
                    </IconButton>
                    {rightContetnt()}
                    {leftContetnt()}
                </Style>
            </Dialog>
        </React.Fragment>
    )
}
export default ModalLogin